module.exports = __webpack_public_path__ + "public/adminIcons/ce2b5b26.svg?ce2b5b26";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/ce2b5b26.svg
// module id = 3330
// module chunks = 8